<template>
  <div class="d-flex flex-column align-items-center bg-white px-4 px-md-5 py-5 w-100" style="max-width: 495px">

    <h4 class="text-uppercase font-weight-bold mb-4">Login</h4>

    <b-form
      @submit.prevent="submit"
      novalidate ref="form"
      class="form-animated"
      :class="{'was-validated' : validation }">
      <b-row>
        <b-col v-for="(input, key) in inputs" :key="key" :md="input.columns">

          <b-form-group v-if="input.type === 'text' || input.type === 'email'" class="mb-4 position-relative">

            <b-form-input
              :id="input.name"
              :type="input.type"
              v-model="form[input.name]"
              :required="input.required"
              :class="{'input-filled' : !!form[input.name]}">
            </b-form-input>

            <div class="invalid-feedback position-absolute mt-0 text-left">
              Please provide a valid value
            </div>

            <label
              :for="input.name"
              class="label-animated">
              {{input.label}}
              <span v-if="input.required" class="text-danger">*</span>
            </label>

          </b-form-group>

          <b-form-group v-if="input.type === 'password'" class="mb-4 position-relative">

            <b-form-input
              :id="input.name"
              :type="inputTypeToggled"
              v-model="form[input.name]"
              :required="input.required"
              :class="{'input-filled' : !!form[input.name]}">
            </b-form-input>

            <label
              :for="input.name"
              class="label-animated">
              {{input.label}}
              <span v-if="input.required" class="text-danger">*</span>
            </label>

            <i class="fas position-absolute text-muted"
               :class="inputTypeToggled === 'password' ?  'fa-eye' : ' fa-eye-slash'"
               @click="togglePasswordVisibility"
               style="right: 8px; top: 6px"></i>

          </b-form-group>
        </b-col>
      </b-row>

      <b-btn
        class="text-uppercase w-100 p-2 mt-2"
        type="submit"
      >
        Login
      </b-btn>

    </b-form>
  </div>
</template>

<script>
  export default {
    name: "registrationPopup",
    data() {
      return {
        validation: false,
        inputs: [
          {
            name: 'email',
            label: 'E-mail',
            type: 'email',
            columns: 12,
            required: true
          },
          {
            name: 'password',
            label: 'Password',
            type: 'password',
            columns: 12,
            required: true
          }
        ],
        form: {
          email: '',
          password: ''
        },
        inputTypeToggled: 'password'
      }
    },
    methods: {
      togglePasswordVisibility() {
        if (this.inputTypeToggled === 'password') {
          this.inputTypeToggled = 'text'
        } else {
          this.inputTypeToggled = 'password'
        }
      },
      submit() {
        this.validation = true;
        if (this.$refs.form.checkValidity()) {
          console.log('Success!')
        } else {
          console.log('Fail!')
        }
        console.log(this.form)
      }
    }
  }
</script>
